'use strict';

window.CFC = window.CFC || {};

window.CFC.GForms = (function($) {
  function init() {
     $('.gfield_required').attr('aria-label', window.cfctx['general.required']);
  }
    
  $(init);
})(jQuery);